type RiskFlagMeta = {
  label: string;
  description: string;
};

const TASK_RISK_REASON_MAP: Record<string, RiskFlagMeta> = {
  task_stale_10d: {
    label: 'Stale 10+ days',
    description: 'No activity on this task for 10 or more days.',
  },
  task_stale_5d: {
    label: 'Stale 5+ days',
    description: 'No activity on this task for 5 or more days.',
  },
  cycle_time_long_30d: {
    label: 'Cycle time 30+ days',
    description: 'This task has been in progress for over 30 days.',
  },
  cycle_time_long_14d: {
    label: 'Cycle time 14+ days',
    description: 'This task has been in progress for over 14 days.',
  },
  task_reopened: {
    label: 'Reopened',
    description: 'This task was completed and then reopened.',
  },
  many_reassignments: {
    label: '3+ reassignments',
    description: 'This task has been reassigned 3 or more times.',
  },
  reassignments_2: {
    label: 'Reassigned twice',
    description: 'This task has changed assignee twice.',
  },
  due_date_passed: {
    label: 'Overdue',
    description: 'The due date for this task has passed.',
  },
};

export function getTaskRiskReasonMeta(key: string): RiskFlagMeta {
  return (
    TASK_RISK_REASON_MAP[key] ?? {
      label: formatFlagKey(key),
      description: '',
    }
  );
}

const RISK_FLAG_MAP: Record<string, RiskFlagMeta> = {
  backlog_growing: {
    label: 'Backlog growing',
    description: 'New tasks are being created but none are completed — the backlog is expanding.',
  },
  throughput_low: {
    label: 'Low throughput',
    description: 'Fewer tasks are being completed than expected relative to creation volume.',
  },
  reopen_high: {
    label: 'High reopen rate',
    description: 'A significant portion of completed tasks are being reopened after closure.',
  },
  cycle_time_high: {
    label: 'High cycle time',
    description: 'Tasks are taking longer than usual to move from start to done.',
  },
  due_date_coverage_low: {
    label: 'Low due date coverage',
    description: 'Most tasks lack a due date, making delivery accuracy estimates unreliable.',
  },
};

function formatFlagKey(key: string): string {
  return key
    .split('_')
    .map((w, i) => (i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ');
}

export function getRiskFlagMeta(key: string): RiskFlagMeta {
  return (
    RISK_FLAG_MAP[key] ?? {
      label: formatFlagKey(key),
      description: '',
    }
  );
}

export function formatRiskFlags(flags: string[]): string {
  return flags.map((f) => getRiskFlagMeta(f).label).join(', ');
}
